<template>
  <div class="relative">
    <img src="@/assets/images/bg_login.jpg" alt="" class="h-screen w-full" />
    <!-- <HeaderTemplate /> -->
    <div class="absolute right-0 top-0 p-10 image1">
      <img :src="img" alt="" class="md:w-[128px]" />
    </div>
    <div class="absolute top-0 justify-center w-full h-full">
      <div class="my-48 flex justify-center">
        <div>
          <div class="p-10 rounded-lg">
            <div class="text-center">
              <div class="font-bold headTitleColor text-5xl leading-tight">
                Customer Service
              </div>
              <div class="textColor font-bold text-4xl leading-normal">
                ADMIN DASHBOARD
              </div>
            </div>
            <div class="flex w-full">
              <table class="w-full">
                <tr>
                  <td class="text-center">
                    <div
                      @click="routeTo('dashboard')"
                      class="
                        hover:bg-red-900
                        bg-red-800
                        mr-1
                        p-10
                        rounded-tl-md rounded-bl-md
                        text-white text-center
                        font-bold
                      "
                    >
                      DASHBOARD
                    </div>
                  </td>
                  <td>
                    <div
                      @click="routeTo('analytics')"
                      class="
                        hover:bg-red-900  
                        ml-1
                        p-10
                        bg-red-800
                        rounded-tr-md rounded-br-md
                        text-white text-center
                        font-bold
                      "
                    >
                      ANALYTICS
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import HeaderTemplate from "@/components/HeaderTemplate"
export default {
  data() {
    return { img: require("@/assets/images/moldex_logo.png") };
  },
  methods: {
    routeTo(e) {
      if (e == "dashboard") {
        if (!this.$route.path.includes("admin-dashboard-screen")) {
          this.$router.push("/admin/admin-dashboard-screen/unassigned-tickets");
         
        }
      } else {
        if (!this.$route.path.includes("analytics")) {
          this.$router.push({ name: "Analytics" });
        }
      }
    },
  },
};
</script>
